import { render, staticRenderFns } from "./MenuModalBtn.vue?vue&type=template&id=c639baf4"
import script from "./MenuModalBtn.vue?vue&type=script&lang=js"
export * from "./MenuModalBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports